import {LoadingOutlined} from "@ant-design/icons";
import React from "react";
import './loadingTail.css'

export function LoadingTail() {
    return (
        <div id="tail-loading"><LoadingOutlined/> Loading data</div>
    )
}